import type { IconSvgProps } from '../Icon.types';

export const MailSimple = ({ fill, width, height, className }: IconSvgProps) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 16 16" >
      <path
        d="M14 3.125H2C1.90054 3.125 1.80516 3.16451 1.73483 3.23483C1.66451 3.30516 1.625 3.40054 1.625 3.5V12C1.625 12.2321 1.71719 12.4546 1.88128 12.6187C2.04538 12.7828 2.26794 12.875 2.5 12.875H13.5C13.7321 12.875 13.9546 12.7828 14.1187 12.6187C14.2828 12.4546 14.375 12.2321 14.375 12V3.5C14.375 3.40054 14.3355 3.30516 14.2652 3.23483C14.1948 3.16451 14.0995 3.125 14 3.125ZM8 8.49125L2.96375 3.875H13.0363L8 8.49125ZM6.35437 8L2.375 11.6475V4.3525L6.35437 8ZM6.90938 8.50875L7.75 9.27625C7.81913 9.33949 7.90943 9.37457 8.00313 9.37457C8.09682 9.37457 8.18712 9.33949 8.25625 9.27625L9.09375 8.50875L13.0363 12.125H2.96438L6.90938 8.50875ZM9.64563 8L13.625 4.3525V11.6475L9.64563 8Z"
        fill={fill}
      />
    </svg>
  );
};
